import { Injectable } from '@angular/core';
import { StipendRequest } from '@models/request';
import { AdminRequestRepository } from '@repositories/admin/admin-request.repository';
import { Observable } from 'rxjs';
import { StateService } from './state.service';

@Injectable({
    providedIn: 'root',
})
export class StipendRequestStateService extends StateService<StipendRequest> {
    constructor(private requestRepository: AdminRequestRepository) {
        super();
    }
    public override get(id: number): Observable<StipendRequest> {
        return this.requestRepository.getStipendRequest(id);
    }
}
